import { Component } from '@angular/core';
import { IPluginPreviewComponent } from '../../../../../interfaces/plugin-preview-component.interface';
import { SoftwareData } from '../../../../../models/wizard-plugin-models/software-data';

@Component({
  selector: 'app-software-preview',
  templateUrl: './software-preview.component.html',
  styleUrl: './software-preview.component.css'
})
export class SoftwarePreviewComponent implements IPluginPreviewComponent {
  public previewData: SoftwareData | undefined;

  setData(data: any): void {
    if (data) {
      this.previewData = data as SoftwareData;
    }
  }
}
